import Cookies from 'js-cookie';
import { Button } from 'ui/components/common';
import { cn, useStorage } from 'utils/helpers';
import { STORAGE_TYPE } from 'utils/helpers/useStorage';

const SessionExpiredModal = () => {
  const { removeItem } = useStorage();

  const onClick = () => {
    removeItem(
      `${import.meta.env.VITE_APP_PREFIX}_profile`,
      STORAGE_TYPE.session,
    );

    removeItem(
      `${import.meta.env.VITE_APP_PREFIX}_profile`,
      STORAGE_TYPE.local,
    );

    removeItem(`${import.meta.env.VITE_APP_PREFIX}_misc`, STORAGE_TYPE.local);

    Cookies.remove('_isEmailAddressVerified');
    Cookies.remove('_isOnboarded');
    Cookies.remove('_role');
    Cookies.remove('_token');
    Cookies.remove('_sessionId');
    Cookies.remove('_onboardingSteps');

    window.location.href = '/login';
  };

  return (
    <div
      className={cn(
        'w-[440px] h-[174px]',
        'text-secondary flex-col justify-start items-start inline-flex shadow-md',
      )}
    >
      <div className="self-stretch h-[106px] flex-col justify-start items-start flex">
        <div className="flex flex-col items-start self-stretch justify-center h-10 ">
          <div
            className={cn(
              'self-stretch h-10 px-4 py-2.5 bg-fill-primary rounded-tl-md',
              'rounded-tr-md justify-start items-center gap-[17px] inline-flex',
            )}
          >
            <div className="grow shrink basis-0 h-[22px] justify-start items-center gap-2 flex">
              <div className="text-sm font-semibold leading-snug tracking-wide grow shrink basis-0">
                Session Expired
              </div>
            </div>
          </div>
        </div>
        <div
          className={cn(
            'self-stretch h-[66px] p-[22px] bg-fill-tertiary border-t',
            'border-separator-primary flex-col justify-start items-start gap-2.5 flex',
          )}
        >
          <div className="self-stretch text-sm font-normal leading-snug tracking-wide">
            Your session has expired. Please log in again.
          </div>
        </div>
      </div>
      <div
        className={cn(
          'self-stretch h-[68px] pl-[22px] pr-2.5 py-4 bg-fill-tertiary rounded-bl-md',
          'rounded-br-md border-t border-separator-primary flex-col justify-start',
          'items-end gap-2.5 flex',
        )}
      >
        <div className="justify-start items-center gap-3.5 inline-flex">
          <Button
            className="primary md"
            onClick={onClick}
            label="OK, GO TO SIGN IN PAGE"
          />
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
